'use client'

import React, { ReactNode } from 'react'
import { getSharedProps } from '@/utils/button.utils'
import { ButtonProps } from '@/types/Button.types'

type Props = ButtonProps & {
  ref?: React.Ref<HTMLAnchorElement>
  suppressHydrationWarning?: boolean
}

/**
 * Anchor button component
 * @param {Props} props - component properties
 * @returns {React.ReactElement} React component
 */
export const AnchorButton = (props: Props): ReactNode => {
  const {
    children,
    icon,
    target,
    href,
    ref,
  } = props

  const sharedProps = getSharedProps(props)

  if (!href) {
    return (
      <span
        {...sharedProps}
        {...(ref ? { ref } : {})}
      >
        {icon}
        <span>
          {children}
        </span>
      </span>
    )
  }

  return (
    <a
      {...sharedProps}
      {...(target ? { target } : {})}
      {...(ref ? { ref } : {})}
      {...(props.suppressHydrationWarning ? { suppressHydrationWarning: props.suppressHydrationWarning } : {})}
    >
      {icon}
      <span>
        {children}
      </span>
    </a>
  )
}
